export default __webpack_public_path__ + "static/media/reload-calendar.59ba66b1.svg";